module.exports = __webpack_public_path__ + "static/media/liushishishan4.4acc5ff6.webp";